import axiosClient from "@/services/shared/api/axios-client";

export type SpeechEvaluationStatus = {
  answerId: string;
  status: "Pending" | "Completed" | "Failed" | string;
  contentScore?: number | null;
  pronunciationScore?: number | null;
  summary?: string | null;
  error?: string | null;
  isCorrect?: boolean;
  feedback?: string | null;
};

export const apiPollSpeechEvaluation = async (
  answerId: string
): Promise<SpeechEvaluationStatus> => {
  const response = await axiosClient.get<SpeechEvaluationStatus>(
    `/students/exercises/speech-evaluation/${answerId}`
  );
  return response.data;
};
